import { useState, useEffect, useRef } from 'react'
import { Icon, Text } from '@leroy-merlin-br/backyard-react-ui'
import {
  ChevronDownSolid,
  ChevronUp
} from '@leroy-merlin-br/backyard-react-icons'

import * as S from './styled'

const EXTRA_HEIGHT = 50

const Accordion = ({ title = '', children, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)
  const [openHeight, setIsOpenHeight] = useState(0)

  const ref = useRef()

  useEffect(() => {
    updateHeight()
  })

  const updateHeight = () =>
    setIsOpenHeight(ref?.current?.scrollHeight + EXTRA_HEIGHT)

  return (
    <S.Card>
      <S.Header onClick={() => setIsOpen(prev => !prev)}>
        <Text as="strong" size="giga" bold noMargin>
          {title}
        </Text>
        <Icon as={!isOpen ? ChevronDownSolid : ChevronUp} size="byte" />
      </S.Header>

      <S.Content ref={ref} isOpen={isOpen} openHeight={openHeight}>
        {children}
      </S.Content>
    </S.Card>
  )
}

export default Accordion
